function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#E5F6ED"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 11,
  width: 20,
  height: 3,
  rx: 1.5,
  fill: "#00A94F"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 16,
  width: 20,
  height: 3,
  rx: 1.5,
  fill: "#00A94F"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 21,
  width: 20,
  height: 3,
  rx: 1.5,
  fill: "#00A94F"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 26,
  width: 20,
  height: 3,
  rx: 1.5,
  fill: "#00A94F"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#E5F6ED"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2353 19.9499C16.2442 21.3794 15.0678 22.571 13.6382 22.5824C12.1982 22.5928 11.0065 21.4092 11 19.9593C10.9936 18.5388 12.1873 17.3442 13.6134 17.3438C14.3052 17.3463 14.9681 17.6212 15.4587 18.1089C15.9494 18.5967 16.2283 19.258 16.2353 19.9499ZM13.6422 18.663C13.4712 18.6577 13.3007 18.6866 13.141 18.7481C12.9813 18.8097 12.8355 18.9025 12.7122 19.0212C12.5888 19.1399 12.4905 19.2821 12.4228 19.4393C12.3552 19.5966 12.3197 19.7658 12.3184 19.937C12.3109 20.6731 12.8691 21.2532 13.5926 21.2612C14.328 21.2696 14.907 20.7123 14.9169 19.9877C14.9221 19.8165 14.8931 19.6459 14.8315 19.4861C14.7699 19.3263 14.677 19.1804 14.5583 19.057C14.4395 18.9336 14.2973 18.8351 14.14 18.7675C13.9827 18.6998 13.8135 18.6643 13.6422 18.663Z",
  fill: "#00A94F"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.611 10.8125C14.3027 10.8097 14.9673 11.0813 15.4592 11.5678C15.9511 12.0542 16.2302 12.7159 16.2353 13.4078C16.2462 14.8382 15.0684 16.0318 13.6408 16.0402C12.944 16.0426 12.2747 15.7685 11.7797 15.278C11.2846 14.7875 11.0043 14.1206 11.0001 13.4236C10.9896 11.9927 12.1715 10.8125 13.611 10.8125ZM12.3199 13.4053C12.3184 13.6619 12.3928 13.9133 12.5339 14.1276C12.675 14.342 12.8764 14.5097 13.1127 14.6098C13.349 14.7098 13.6096 14.7375 13.8617 14.6896C14.1137 14.6416 14.3459 14.5201 14.529 14.3403C14.7121 14.1605 14.8378 13.9304 14.8904 13.6792C14.9429 13.428 14.9199 13.1669 14.8243 12.9287C14.7286 12.6906 14.5646 12.4861 14.3529 12.3411C14.1412 12.1961 13.8914 12.117 13.6348 12.1139C13.4636 12.1116 13.2937 12.1433 13.1347 12.2069C12.9758 12.2706 12.831 12.3651 12.7087 12.4849C12.5864 12.6047 12.4889 12.7475 12.4219 12.9051C12.355 13.0627 12.3198 13.232 12.3184 13.4033L12.3199 13.4053Z",
  fill: "#00A94F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5975 28.8105C12.9059 28.8045 12.2447 28.5252 11.7582 28.0336C11.2716 27.5419 10.9991 26.8778 11 26.186C11.003 24.7456 12.2047 23.5694 13.6551 23.5863C15.0867 23.6032 16.2601 24.8052 16.2372 26.2297C16.2284 26.9218 15.9456 27.5822 15.4508 28.066C14.9559 28.5498 14.2894 28.8176 13.5975 28.8105ZM12.3189 26.2069C12.3218 26.4635 12.4007 26.7136 12.5456 26.9254C12.6904 27.1373 12.8948 27.3015 13.1329 27.3973C13.3709 27.4932 13.632 27.5163 13.8832 27.4639C14.1344 27.4114 14.3645 27.2857 14.5443 27.1026C14.7242 26.9195 14.8458 26.6873 14.8938 26.4351C14.9419 26.183 14.9141 25.9222 14.8142 25.6858C14.7142 25.4494 14.5465 25.2479 14.3322 25.1067C14.1179 24.9656 13.8665 24.891 13.6099 24.8926C13.4387 24.8936 13.2695 24.9285 13.1118 24.9952C12.9541 25.0619 12.8112 25.1591 12.6912 25.2812C12.5713 25.4034 12.4766 25.548 12.4127 25.7069C12.3488 25.8657 12.3169 26.0356 12.3189 26.2069Z",
  fill: "#00A94F"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7821 20.6227C21.3321 20.6227 19.882 20.6227 18.4317 20.6227C18.2892 20.6263 18.1467 20.6121 18.0077 20.5804C17.8739 20.5429 17.7559 20.4629 17.6716 20.3525C17.5872 20.242 17.5411 20.1071 17.5401 19.9682C17.539 19.8292 17.5832 19.6936 17.666 19.582C17.7487 19.4703 17.8655 19.3886 17.9987 19.3491C18.1171 19.3187 18.239 19.3044 18.3612 19.3064C21.3022 19.3041 25.243 19.3041 28.1843 19.3064C28.6943 19.3064 29.0071 19.5687 28.9987 19.976C28.9902 20.3654 28.6923 20.6217 28.222 20.6217C27.15 20.6261 25.0777 20.6217 24.0056 20.6217L22.7821 20.6227Z",
  fill: "#00A94F"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7742 12.7749C24.2546 12.7749 26.7347 12.769 28.2147 12.7824C28.415 12.7852 28.6105 12.845 28.7782 12.9547C28.9941 13.1037 29.0438 13.356 28.9638 13.6158C28.8839 13.8756 28.6972 14.0206 28.4366 14.0673C28.3353 14.0796 28.2331 14.0829 28.1313 14.0773H18.4019C18.3408 14.0773 18.2792 14.0773 18.2182 14.0773C17.827 14.0594 17.5455 13.7882 17.543 13.4281C17.5405 13.068 17.815 12.7878 18.2107 12.7794C18.6903 12.769 19.1704 12.7754 19.6504 12.7754L22.7742 12.7749Z",
  fill: "#00A94F"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7827 26.81C21.302 26.81 19.8212 26.815 18.341 26.8041C18.1495 26.8048 17.9612 26.7553 17.7947 26.6605C17.5693 26.5214 17.4968 26.2746 17.5599 26.0148C17.6269 25.7431 17.8116 25.5762 18.0872 25.5206C18.1681 25.509 18.2499 25.5053 18.3315 25.5097C21.2927 25.5097 25.2537 25.5097 28.2152 25.5097C28.7147 25.5097 29.0276 25.7918 28.9968 26.2051C28.969 26.5776 28.6929 26.8105 28.2519 26.8115C26.7638 26.812 24.2734 26.81 22.7827 26.81Z",
  fill: "#00A94F"
});

function SvgIconBoxWidgetsMenuList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxWidgetsMenuList);
export default __webpack_public_path__ + "static/media/icon_box-widgets-menu-list.e68cb86c.svg";
export { ForwardRef as ReactComponent };